// extracted by mini-css-extract-plugin
export var button = "styles-module--button--B-LOl";
export var primary = "styles-module--primary--zPWlJ";
export var black = "styles-module--black--Ld4Go";
export var blackLight = "styles-module--blackLight--5RNiG";
export var transparent = "styles-module--transparent--yMj6k";
export var teal = "styles-module--teal--AQ1YA";
export var golden = "styles-module--golden--Ue1Fm";
export var greyBack = "styles-module--greyBack--bok0i";